export function formatPercentage(
  value,
  { minimumFractionDigits = 0, maximumFractionDigits = 3 } = {},
) {
  if (value === null || value === undefined || value === "") return "-";
  const percentage = Number(value);
  if (!Number.isFinite(percentage)) return "-";
  const minimum = Math.max(0, Math.min(20, minimumFractionDigits));
  const maximum = Math.max(minimum, Math.min(20, maximumFractionDigits));
  return `${percentage.toLocaleString("en-US", {
    useGrouping: false,
    minimumFractionDigits: minimum,
    maximumFractionDigits: maximum,
  })}%`;
}
